export default "__VITE_ASSET__9Bs45iNR__"